const server = JSON.parse(localStorage.getItem("dataBranch1"));
export const userServer = server ? server.connection : null;
export const googleMapApiKey = "AIzaSyB1wTcrhxag0w5wmqHK7MYSLq80sWrnzGw";
export const router = "";
export const imageBaseUrl = " https://posimages.s3.ap-southeast-1.amazonaws.com/"
export const keyEncryption = "KBa2HxRmxi7i4v6dUa0bFAmRGbN0ACAi9t3ExsNY4svgoz7YMbBXiCHJ6QiW1MFE";

// PRODUCTION MODE
export const baseUrl = 'https://tableqr.uruz.id/tableqr/'
export const url = 'https://hot.uruz.id/api/'
export const mode_env = "prod"
export const modePayment = "prod";

// DEVELOPMENT MODE
// export const baseUrl = "https://cool.uruz.id/tableqr/";
// export const url = "https://cool.uruz.id/api/";
// export const mode_env = "dev"
// export const modePayment = "dev"
